import { useAppContext } from 'contexts/AppContext';
import { UserBillingType } from 'globals/types';

export const useBillingType = (type: UserBillingType): boolean => {
  const { userBillingType } = useAppContext();
  return userBillingType === type;
};
